import { render, staticRenderFns } from "./ClassRoomSectionEdit.vue?vue&type=template&id=952ede86&scoped=true&"
import script from "./ClassRoomSectionEdit.vue?vue&type=script&lang=js&"
export * from "./ClassRoomSectionEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClassRoomSectionEdit.vue?vue&type=style&index=0&id=952ede86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952ede86",
  null
  
)

export default component.exports